import type { ImageProps } from "next/image";
import Head from "next/head";
import { lazy, Suspense } from "react";

import styles from "./platforms-image.module.scss";

const Image = lazy(() => import("next/image"));

export interface PlatformsImage extends ImageProps {
  preload?: boolean;
}

export default function PlatformsImage({
  preload,
  src: srcProp,
  alt,
  style,
  ...rest
}: PlatformsImage) {
  const src =
    srcProp ??
    "https://sync-platforms.s3.sa-east-1.amazonaws.com/logo-default.svg";

  const mergedStyle = { ...style, userSelect: "none" };

  return (
    <>
      {preload && (
        <Head>
          <link
            rel="preload"
            href={src as string}
            as="image"
            fetchPriority="high"
          />
        </Head>
      )}

      <Suspense fallback={<div className={styles.skeleton} />}>
        <Image
          {...rest}
          src={src}
          alt={alt ?? `Image - ${src}`}
          style={{ ...mergedStyle, userSelect: "none" as const }}
        />
      </Suspense>
    </>
  );
}
